import { useState, useEffect } from "react";
import { Navigation } from "./navigation";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export const PricingPage = () => {
    const [model, setModel] = useState("Multilingual");
    const [billing, setBilling] = useState("Monthly");
    const [currency, setCurrency] = useState("USD");

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);

    const navigate = useNavigate();

    const pricingByCurrency = {
        Monthly: [
            {
                name: "Free",
                description: "For individuals exploring the power of conversational AI with lifelike voice agents.",
                price: {
                    USD: { Monthly: "$0", Annual: "$0" },
                    EUR: { Monthly: "€0", Annual: "€0" },
                    INR: { Monthly: "₹0", Annual: "₹0" }
                },
                month: "per month",
                rates: [
                    "Credits: 600",
                    "~ 10 minutes of talk time"
                ],
                features: [
                    "Access to 100+ global languages",
                    "Upload upto 10 knowledge files",
                    "1 concurrent call",
                    "8 voice options"
                ]
            },
            {
                name: "Starter",
                description: "For builders and hobbyists experimenting with AI voice agents in personal projects.",
                price: {
                    USD: { Monthly: "$10", Annual: "$8" },
                    EUR: { Monthly: "€9.14", Annual: "€7.31" },
                    INR: { Monthly: "₹861", Annual: "₹689" }
                },
                month: "per month",
                rates: [
                    "Credits: 6,000",
                    "~ 100 minutes of talk time",
                    "Add on minutes at 60 credits/min",
                    "AI analytics at 18 credits/conversation",
                    "Telephony integration: Country based standard telco fees"
                ],
                features: [
                    "Access to 100+ global languages",
                    "Upload upto 10 knowledge files",
                    "1 concurrent call",
                    "8 voice options"
                ]
            },
            {
                name: "Pro",
                description: "For creators and teams launching real-time voice interactions at scale.",
                price: {
                    USD: { Monthly: "$50", Annual: "$40" },
                    EUR: { Monthly: "€45.69", Annual: "€36.55" },
                    INR: { Monthly: "₹4,308", Annual: "₹3,446" }
                },
                month: "per month",
                offer: "FIRST MONTH 50% OFF",
                rates: [
                    "Credits: 30,000",
                    "~ 500 minutes of talk time",
                    "Add on minutes at 54 credits/min",
                    "AI analytics at 18 credits/conversation",
                    "Telephony integration: Country based standard telco fees"
                ],
                features: [
                    "Access to 100+ global languages",
                    "Upload upto 10 knowledge files",
                    "3 concurrent call",
                    "8 voice options",
                    "SMS/Whatsapp integration"
                ]
            },
            {
                name: "Scale",
                description: "For fast-growing startups and publishers deploying voice agents across channels.",
                price: {
                    USD: { Monthly: "$200", Annual: "$160" },
                    EUR: { Monthly: "€182.75", Annual: "€146.20" },
                    INR: { Monthly: "₹17,233", Annual: "₹13,786" }
                },
                month: "per month",
                rates: [
                    "Credits: 1,20,000",
                    "~ 2000 minutes of talk time",
                    "Add on minutes at 48 credits/min",
                    "AI analytics at 18 credits/conversation",
                    "Telephony integration: Country based standard telco fees"
                ],
                features: [
                    "Access to 100+ global languages",
                    "Upload upto 10 knowledge files",
                    "5 concurrent call",
                    "8 voice options",
                    "SMS/Whatsapp integration",
                    "Custom API integrations"
                ]
            },
            {
                name: "Enterprise",
                description: "For organizations that need high-volume usage, custom integrations, and enterprise-grade support.",
                // price: "Contact Us",
                rates: [
                    "Credits: Custom",
                    "Custom AI analytics portal",
                    "Telephony integration: Custom telco fees"
                ],
                features: [
                    "Access to 100+ global languages",
                    "Upload multiple knowledge files",
                    "Custom concurrent call limits",
                    "Voice cloning option",
                    "SMS/Whatsapp integration",
                    "1000+ custom integrations"
                ]
            }
        ],
        Annual: [
            {
                name: "Free",
                description: "For individuals exploring the power of conversational AI with lifelike voice agents.",
                price: {
                    USD: { Monthly: "$0", Annual: "$0" },
                    EUR: { Monthly: "€0", Annual: "€0" },
                    INR: { Monthly: "₹0", Annual: "₹0" }
                },
                month: "per month",
                rates: [
                    "Credits: 600",
                    "~ 10 minutes of talk time"
                ],
                features: [
                    "Access to 100+ global languages",
                    "Upload upto 10 knowledge files",
                    "1 concurrent call",
                    "8 voice options"
                ]
            },
            {
                name: "Starter",
                description: "For builders and hobbyists experimenting with AI voice agents in personal projects.",
                price: {
                    USD: { Monthly: "$10", Annual: "$8" },
                    EUR: { Monthly: "€9.14", Annual: "€7.31" },
                    INR: { Monthly: "₹861", Annual: "₹689" }
                },
                month: "per month",
                rates: [
                    "Credits: 6,000",
                    "~ 100 minutes of talk time",
                    "Add on minutes at 60 credits/min",
                    "AI analytics at 18 credits/conversation",
                    "Telephony integration: Country based standard telco fees"
                ],
                features: [
                    "Access to 100+ global languages",
                    "Upload upto 10 knowledge files",
                    "1 concurrent call",
                    "8 voice options"
                ]
            },
            {
                name: "Pro",
                description: "For creators and teams launching real-time voice interactions at scale.",
                price: {
                    USD: { Monthly: "$50", Annual: "$40" },
                    EUR: { Monthly: "€45.69", Annual: "€36.55" },
                    INR: { Monthly: "₹4,308", Annual: "₹3,446" }
                },
                month: "per month",
                offer: "FIRST MONTH 50% OFF",
                rates: [
                    "Credits: 30,000",
                    "~ 500 minutes of talk time",
                    "Add on minutes at 54 credits/min",
                    "AI analytics at 18 credits/conversation",
                    "Telephony integration: Country based standard telco fees"
                ],
                features: [
                    "Access to 100+ global languages",
                    "Upload upto 10 knowledge files",
                    "3 concurrent call",
                    "8 voice options",
                    "SMS/Whatsapp integration"
                ]
            },
            {
                name: "Scale",
                description: "For fast-growing startups and publishers deploying voice agents across channels.",
                price: {
                    USD: { Monthly: "$200", Annual: "$160" },
                    EUR: { Monthly: "€182.75", Annual: "€146.20" },
                    INR: { Monthly: "₹17,233", Annual: "₹13,786" }
                },
                month: "per month",
                rates: [
                    "Credits: 1,20,000",
                    "~ 2000 minutes of talk time",
                    "Add on minutes at 48 credits/min",
                    "AI analytics at 18 credits/conversation",
                    "Telephony integration: Country based standard telco fees"
                ],
                features: [
                    "Access to 100+ global languages",
                    "Upload upto 10 knowledge files",
                    "5 concurrent call",
                    "8 voice options",
                    "SMS/Whatsapp integration",
                    "Custom API integrations"
                ]
            },
            {
                name: "Enterprise",
                description: "For organizations that need high-volume usage, custom integrations, and enterprise-grade support.",
                // price: "Contact Us",
                rates: [
                    "Credits: Custom",
                    "Custom AI analytics portal",
                    "Telephony integration: Custom telco fees"
                ],
                features: [
                    "Access to 100+ global languages",
                    "Upload multiple knowledge files",
                    "Custom concurrent call limits",
                    "Voice cloning option",
                    "SMS/Whatsapp integration",
                    "1000+ custom integrations"
                ]
            }
        ]
    };

    return (
        <div id="pricing-page">
            <Navigation />
            <div className="pricing-heading section-title">
                <h2>Compare our plans and find the right fit</h2>
                <p>Plans built for creators and businesses of all sizes.</p>
            </div>

            <div className="pricing-container">
                <div className="pricing-filters">
                    <div className="pricing-filter-1">
                        <div className="filter-name">Model</div>
                        <div className="filter-button">
                            <button
                                className={model === "Multilingual" ? "active" : ""}
                                onClick={() => setModel("Multilingual")}
                            >
                                Orbit
                            </button>
                            <button
                                className={model === "Voice Pipeline" ? "active" : ""}
                                onClick={() => setModel("Voice Pipeline")}
                            >
                                Quantum
                            </button>
                        </div>
                    </div>

                    <div className="pricing-filter-2">
                        <div className="currency-filter">
                            <div className="filter-name">Currency</div>
                            <div className="filter-button">
                                <button
                                    className={currency === "USD" ? "active" : ""}
                                    onClick={() => setCurrency("USD")}
                                >
                                    USD
                                </button>
                                <button
                                    className={currency === "EUR" ? "active" : ""}
                                    onClick={() => setCurrency("EUR")}
                                >
                                    EUR
                                </button>
                                <button
                                    className={currency === "INR" ? "active" : ""}
                                    onClick={() => setCurrency("INR")}
                                >
                                    INR
                                </button>
                            </div>
                        </div>

                        <div className="billing-filter">
                            <div className="filter-name">Billing</div>
                            <div className="filter-button">
                                <button
                                    className={billing === "Monthly" ? "active" : ""}
                                    onClick={() => setBilling("Monthly")}
                                >
                                    Monthly
                                </button>
                                <button
                                    className={billing === "Annual" ? "active" : ""}
                                    onClick={() => setBilling("Annual")}
                                >
                                    Annual
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pricing-row">
                    {pricingByCurrency[billing].slice(0, 4).map((plan) => (
                        <div key={plan.name} className={`pricing-card ${plan.name === "Pro" ? "selected" : ""}`}>
                            {plan.name === "Pro" && <div className="most-popular-label">Most Popular</div>}

                            <div className="pricing-header">
                                <div className="pricing-details">
                                    <div className="pricing-details-heading">
                                        <h3>{plan.name}</h3>
                                        <p>{plan.description}</p>
                                    </div>
                                    <div className="pricing-details-price">
                                        <p id="price">{plan.price?.[currency]?.[billing] ?? "N/A"}</p>
                                        <p className="per-month">{plan.month}</p>
                                    </div>
                                </div>

                                {plan.offer && (
                                    <div className="pricing-details-offer">
                                        <p className="offer">{plan.offer}</p>
                                    </div>
                                )}

                                {/* <button
                                    className="get-started"
                                    onClick={() => navigate("/billing", { state: { plan, billing, currency } })}
                                >
                                    Get Started
                                </button> */}

                                <button
                                    className="get-started"
                                    onClick={() => navigate("/contact")}
                                >
                                    Get Started
                                </button>

                            </div>

                            <div className="pricing-features">
                                <p className="features-header">Rates:</p>
                                <ul>
                                    {plan.rates.map((rate, idx) => (
                                        <li key={idx}>{rate}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className="pricing-features">
                                <p className="features-header">Features:</p>
                                <ul>
                                    {plan.features.map((feature, idx) => (
                                        <li key={idx}>{feature}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="pricing-row second-row">
                    <div className="business-text">
                        <div className="business-text-content">
                            <div>
                                <h3>AI Voice Agents That Sound Real, Act Smart, and Drive Results</h3>
                            </div>
                            <div className="pricing-page-image">
                                <img src="./img/pricing-image.jpg" alt="pricing-page" />
                            </div>
                            <div className="pricing-disclaimer">
                                <p>Free tier requires attribution and does not have commercial licensing.*</p>
                                <p>Billing prices will be calculated as per the latest exchange rates.**</p>
                            </div>
                        </div>
                    </div>

                    <div className="pricing-card last-card">
                        <div className="pricing-header">
                            <div className="pricing-details">
                                <div className="pricing-details-heading">
                                    <h3>{pricingByCurrency[billing][4].name}</h3>
                                    <p>{pricingByCurrency[billing][4].description}</p>
                                </div>

                                <div className="pricing-details-price">
                                    <Link to="/contact">
                                        <p className="pricing-contact">Contact Us</p>
                                    </Link>
                                    <p className="price">
                                        {pricingByCurrency[billing][4].price?.[currency]?.[billing]}
                                    </p>
                                </div>
                            </div>
                            <button className="get-started" onClick={() => navigate("/contact")}>Get Started</button>
                        </div>

                        <div className="pricing-features">
                            <p className="features-header">Rates:</p>
                            <ul>
                                {pricingByCurrency[billing][4].rates.map((rate, idx) => (
                                    <li key={idx}>{rate}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="pricing-features">
                            <p className="features-header">Everything in Scale, plus:</p>
                            <ul>
                                {pricingByCurrency[billing][4].features.map((feature, idx) => (
                                    <li key={idx}>{feature}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                {/* <Link to="/billing">
                    <button className="btn btn-custom">
                        Billing Page
                    </button>
                </Link> */}
            </div>
        </div>
    );
};